<template>
    <v-container class="pa-2" fluid grid-list-sm > 

        <v-card class="shadow-none app-page-card" v-if="content">
            <v-card-title>
                Competition: {{competition_name}} <br />
            </v-card-title>
            <table class="show-competition-quick-info-table">
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Score:</td><td class="show-competition-quick-info-table__data">{{content.score}} + {{content.teacher_score}} =  {{content.score + content.teacher_score}}</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Spent time:</td><td class="show-competition-quick-info-table__data">{{content.spent_time}} s ({{Math.floor(content.spent_time/3600)}} h {{Math.floor((content.spent_time % 3600)/60)}} min {{Math.floor(content.spent_time % 3600 % 60)}} s)</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Begin at:</td><td class="show-competition-quick-info-table__data">{{content.begin_at}}</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">End at:</td><td class="show-competition-quick-info-table__data">{{content.end_at}}</td>
                </tr>
            </table>
            {{content.description}} <br>

            <div class="show-competition-main-table">
                <div class="show-competition-main-table__heading">
                    <div class="show-competition-main-table-heading__item"></div>
                    <div class="show-competition-main-table-heading__item"></div>
                    <div class="show-competition-main-table-heading__item">auto-score</div>
                    <div class="show-competition-main-table-heading__item">teacher-score</div>
                    <div class="show-competition-main-table-heading__item">sum</div>
                    <div class="show-competition-main-table-heading__item">attempts</div>
                    <div class="show-competition-main-table-heading__item">comment</div>
                    <div class="show-competition-main-table-heading__item"></div>
                </div>

                <div class="show-competition-main-table__data-group cursor-pointer" v-for="(task, index) in content.task_list" :key="index">
                    <div class="show-competition-main-table__row" @click="showAtts(index)">
                            <div class="show-competition-main-table-row__item">{{index+1}}.</div>
                            <div class="show-competition-main-table-row__item"><v-icon> {{getTaskIcon(task.task_type_id)}}</v-icon></div>
                            <div class="show-competition-main-table-row__item">{{task.score}}</div>
                            <div class="show-competition-main-table-row__item">{{task.teacher_score}}</div>
                            <div class="show-competition-main-table-row__item">{{task.score + task.teacher_score}} / {{task.max_score}}</div>
                            <div class="show-competition-main-table-row__item"><v-icon>play_for_work</v-icon> {{task.attempts}}</div>
                            <div class="show-competition-main-table-row__item"><div v-if="task.comment" v-html="processComment(task.comment)"></div></div>
                            <div class="show-competition-main-table-row__item justify-content-center">
                                <v-icon v-if="showAttempts != index">expand_more</v-icon>
                                <v-icon v-if="showAttempts == index">expand_less</v-icon>
                            </div>
                    </div>
                    <div :class="[showAttempts == index ? 'show-attempts-content--active' : 'show-attempts-content']" v-if="showAttempts == index">
                            <v-icon @click="showAttempts = -1" class="float-right show-attempts-content__close-icon">close</v-icon>

                            <div class="show-attempts-content__side-menu" v-if="task.task_type_id >= 8">
                                <h4 class="show-attempts-content__title">Attempts:</h4>
                                <div v-for="(attempt, index2) in task.attempt_list" :key="index2" @click="showCode = index2" :class="[showCode == index2 ? 'show-attempts-content__side-code-area show-attempts-content__side-code-area--active' : 'show-attempts-content__side-code-area']">
                                    <span class="competition-result__code-link">
                                        {{index2+1}}. {{attempt.time_stamp}} (score: <b>{{attempt.score}}</b>)
                                    </span>
                                    <div v-if="showCode == index2" class="competition-result__code-editor">
                                        <CodesInEditor v-bind:answer="attempt.answer" />
                                    </div>
                                </div>
                            </div>


                            <div class="show-attempts-content__side-menu" v-if="task.task_type_id < 8">
                                <h4 class="show-attempts-content__title">Attempts:</h4>
                                <div v-for="(attempt, index2) in task.attempt_list" :key="index2" @click="showCode = index2" :class="[showCode == index2 ? 'show-attempts-content__side-code-area show-attempts-content__side-code-area--active' : 'show-attempts-content__side-code-area']">
                                    <span class="competition-result__code-link">
                                        {{index2+1}}. {{attempt.time_stamp}} (score: <b>{{attempt.score}}</b>)
                                    </span>
                                    <div v-if="showCode == index2" class="competition-result__text-answer">
                                        <ul class="answer-list">
                                            <li v-for="(answer, index3) in JSON.parse(attempt.answer)" :key="index3">{{answer}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import CodesInEditor from '../../elements/programming/codes_in_editor.vue'
import * as misc from '../../assets/misc.js'
import * as icn from '../../assets/task_icons.js'
import axios from '../../axios-auth.js'
// import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            showAttempts: -1,
            showCode: -1,
            content:null,
            lessons:[],
            course_id: -1,
            competition_id: -1, 
            competition_name: ''
        }
    },
    // props: ['content','competition_name'],
    components: {
        CodesInEditor
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            axios.get('/get-my-competition/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.lessons = res.data 
                    this.course_id = res.data.course.id
                    this.competition_id = res.data.competition.id
                    this.competition_name = res.data.competition.name

                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id },//#                    
                        { text: res.data.competition.name, href: '/competition_content/' + res.data.competition.id },//#                    
                    ]
                    this.$store.commit('setBreadCrumbs',bc)   

                    this.getCourseInfo()
                    this.getCompetitionLessons()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        getCourseInfo() {
            axios.get('/get-vpl-course-info/' + this.course_id, this.$store.getters.getAxiosConfig )
                .then((res) => {
                    this.$store.commit('setEditorType',res.data.editorType)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                
        },
        getCompetitionLessons() {
            axios.get('/get-active-competition/' 
                      + this.course_id + '/'+
                      + this.$route.params.id 
                      , this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.content = res.data
                    this.content.teacher_score = 0
                    for(let i = 0; i< this.content.task_list.length; i++)
                          this.content.teacher_score = this.content.teacher_score + this.content.task_list[i].teacher_score
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },    
        getTaskIcon(index) {
            return icn.getTaskIcon(index)
        },
        showAtts(index) {
            this.showCode = -1
            if (this.showAttempts == index) this.showAttempts = -1
            else this.showAttempts = index
        },
        getShorterComment(comment) {
            if(comment != "") {
                return comment.substring(0, 50)+"...";
            }
            return "hello";
        }, 
        processComment(comment) {
            return '- ' + misc.hardReplace(comment,'\n','<br>- ')
        }
    }
}
</script>

